import { ESTADO_DO_PASSO_DO_PLANO } from '@modules/aawz-intelligence-v2/constants/TextChat'

// Os estados de que um passo NÃO sai mais: o atalho terminou de tratá-lo, com
// êxito ou não. `falhou` entra aqui de propósito — "falha parcial não derruba
// a entrega" (spec-001 US-2), e o motivo da falha é justamente o que o
// consultor precisa reler depois que o turno fechou.
const ESTADOS_TERMINAIS = [ESTADO_DO_PASSO_DO_PLANO.CONCLUIDO, ESTADO_DO_PASSO_DO_PLANO.FALHOU]

/**
 * O plano do turno chegou ao FIM? — gap Q-0741 (QA de tela, spec-004).
 *
 * É esta resposta, e não "o turno ainda está rodando", que decide se o
 * Progress sobrevive ao `end`: o quadro final é um registro do que foi feito
 * (4 passos riscados), enquanto um plano parado no 2º passo, congelado para
 * sempre na bolha, afirmaria que há trabalho em curso numa resposta que já
 * acabou.
 *
 * @param {Object} plano `{versao, itens: [{id, texto, estado, erro?}]}`.
 * @returns {boolean} `true` só quando há passos E nenhum deles ficou
 *   `pendente`/`em_andamento`.
 */
export function planoTerminado(plano) {
  const itens = (plano && plano.itens) || []
  if (!Array.isArray(itens) || !itens.length) return false
  return itens.every(function (item) {
    return ESTADOS_TERMINAIS.indexOf((item && item.estado) || '') !== -1
  })
}
